import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
 
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from '../../config/index'
import PageShell from "../../components/UI/PageShell";
const { API_URL } = config

const ChangePassword = ({ history }) => {
    const token = localStorage.getItem('token')

    const [oldPassword, setOldPassword]               = useState('')
    const [newPassword, setNewPassword]               = useState('')
    const [confirmNewPassword, setConfirmNewPassword] = useState('')

    const oldPasswordHandler        = e => setOldPassword(e.target.value)
    const newPasswordHandler        = e => setNewPassword(e.target.value)
    const confirmNewPasswordHandler = e => setConfirmNewPassword(e.target.value)

    const submitHandler = async (e) => {
        e.preventDefault()
        if (newPassword === confirmNewPassword) {
            let url = `${API_URL}/associate/change-password`

            try {
                let data = {
                    old_password: oldPassword,
                    new_password: newPassword,
                }

                let response = await fetch(url, {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    withCredentials: true,
                    mode: 'cors',
                    headers: {
                        "Authorization": token,
                        "Access-Control-Allow-Origin": "*",
                        "Content-Type": "application/json; charset=utf-8",
                    }
                })

                let json = await response.json()
                
                if (response.ok) {
                    ToastUtil.success('Password successfully updated. Please login again using the updated password.')
                    history.push('/logout')
                } else {
                    ToastUtil.error(json.message)
                }
            } catch (error) {
                console.log(error)
            }
        } else {
            ToastUtil.error('Password don\'t match!')
        }
    }

    return (
        <PageShell
          title="Change password"
          eyebrow="Security"
          description="Choose a new password to keep your employee account secure."
          backTo="/setting"
        >
            <form className="portal-form-card" onSubmit={e => submitHandler(e)}>
                <div className="portal-form-section-title">
                  <h2>Password details</h2>
                  <p>Enter your current password before setting a new one.</p>
                </div>
                <div className="form-group">
                  <label htmlFor="current-password">Current password</label>
                  <input id="current-password" type="password" placeholder="Enter current password" className="form-control" value={oldPassword} onChange={e => oldPasswordHandler(e)} />
                </div>
                <div className="form-group">
                  <label htmlFor="new-password">New password</label>
                  <input id="new-password" type="password" placeholder="Enter new password" className="form-control" value={newPassword} onChange={e => newPasswordHandler(e)} />
                </div>
                <div className="form-group">
                  <label htmlFor="confirm-password">Confirm new password</label>
                  <input id="confirm-password" type="password" placeholder="Repeat new password" className="form-control" value={confirmNewPassword} onChange={e => confirmNewPasswordHandler(e)} />
                </div>
                <button type="submit" className="btn btn-design btn-brand btn-block mt-4">Save Changes</button>
            </form>
        </PageShell>
    )
}

export default withRouter(ChangePassword)
